import { render } from "./CameraTest.vue?vue&type=template&id=2fbf82f7"
import script from "./CameraTest.vue?vue&type=script&lang=js"
export * from "./CameraTest.vue?vue&type=script&lang=js"

import "@/css/cameraTest.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__